import { title } from "assets/jss/material-kit-react.jsx";
import imagesStyle from "assets/jss/material-kit-react/imagesStyles.jsx";

const productStyle = {
  ...imagesStyle,
  section: {
    padding: "70px 0",
    textAlign: "center",
    backgroundColor: "#e5e5e5",
    "& p": {
      padding: "0px 0px 10px 0px"
    },
    "& p:last-of-type": {
      padding: "20px 0px 10px 0px"
    },
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    textAlign: "left",
    paddingLeft: "30px",
    paddingRight: "30px",
    "@media (min-width: 768px)": {
      paddingLeft: "100px",
      paddingRight: "100px"
    },
    "& sup": {
      fontSize: "50%"
    }
  },
  subtitle: {
    color: "#6c757d"
  },
  description: {
    color: "#999"
  },
  inlineBlock: {
    display: "inline-block"
  }
};

export default productStyle;
